export default "__VITE_ASSET__DOuYL8H3__"